import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddGoToTest } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddGoToTestPage: FC = () => {
  const { accessToAddGototest } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToAddGototest}>
      <CabinetTitlePage title={'Go To Test'} goBack={'/cabinet/facebook/go-to-test'} />
      <AddGoToTest />
    </Guard>
  );
};

export default AddGoToTestPage;
